import MovieCard from '@/components/base/MovieCard';
import { movies } from '@/mocks/data';

interface MovieGridProps {
  categorySlug: string;
}

export default function MovieGrid({ categorySlug }: MovieGridProps) {
  const filtered = movies.filter((m) => m.category === categorySlug);

  if (filtered.length === 0) {
    return (
      <div className="text-center py-20">
        <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-background-200/40">
          <i className="ri-movie-2-line text-3xl text-foreground-500"></i>
        </div>
        <p className="text-foreground-500">该分类暂无影片，请浏览其他分类</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-3 md:gap-5">
      {filtered.map((movie) => (
        <MovieCard key={movie.id} {...movie} />
      ))}
    </div>
  );
}